<template>
  <div
    :class="{'basic': params.typeMenuDigital == 'basic' || params.typeMenuDigital == 'medium'}"
    id="carta-iframe"
  >
    <div class="button-menu-digital-language" v-if="params.languageMenuActivate">
      <span v-if="getAvailableLang('spanish')" class="button-menu-digital-language-pointer" :class="{'button-menu-digital-language-active': multiLanguage === 'spanish'}" @click="getMenu(vendor.id, 'spanish')">ES</span>
      <span v-if="(getAvailableLang('spanish') && getAvailableLang('french')) || (getAvailableLang('spanish') && getAvailableLang('english'))"> / </span>
      <span v-if="getAvailableLang('english')" class="button-menu-digital-language-pointer" :class="{'button-menu-digital-language-active': multiLanguage === 'english'}" @click="getMenu(vendor.id, 'english')">EN</span>
      <span v-if="(getAvailableLang('english') && getAvailableLang('french') && getAvailableLang('spanish')) || (getAvailableLang('english') && getAvailableLang('french') && !getAvailableLang('spanish'))"> / </span>
      <span v-if="getAvailableLang('french')" class="button-menu-digital-language-pointer" :class="{'button-menu-digital-language-active': multiLanguage === 'french'}" @click="getMenu(vendor.id, 'french')">FR</span>
    </div>
    <img
      :key="'images'+ index"
      :src="img.url"
      alt
      class="image-carta"
      v-for="(img,index) in images"
    />
    <button
      @click="sendWhatsapp"
      id="whatsapp"
      title="Escribir por Whatsapp"
      v-if="params.whatsappNumber"
    >
      <i class="fa fa-whatsapp" style="color: #ffffff;font-size: 30px;"></i>
    </button>
  </div>
</template>
<script>
import globalTypes from '@/store/types/global';
export default {
  data () {
    return {
      images: [],
      isFullPage: true
    };
  },
  mounted () {
    const orderLangs = this.params.availableLanguages.split(',').sort((a, b) => {
      const order = { spanish: 1, english: 2, french: 3 };
      return (order[a] || 0) - (order[b] || 0);
    });
    if (this.params.languageMenuActivate && this.params.availableLanguages && this.params.availableLanguages !== null) {
      if (this.multiLanguage !== orderLangs[0]) {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, this.multiLanguage);
      } else {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, orderLangs[0]);
      }
    }
    this.getMenu(this.vendor.id, this.multiLanguage);
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', 'Menu Digital');
    }
  },
  computed: {
    getAvailableLang () {
      return (value) => {
        if (this.params.availableLanguages && this.params.availableLanguages !== null) {
          const arrayLangs = this.params.availableLanguages.split(',');
          if (arrayLangs.find(lang => lang === value)) {
            return true;
          }
          return false;
        }
        return true;
      };
    }
  },
  methods: {
    getMenu (id, language) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el
      });
      this.images = [];
      this.$store.commit(globalTypes.mutations.setMultiLanguage, language);
      this.$store.dispatch({ type: 'whiteLabel:imageMenuDigital', data: { vendorId: id, language } })
        .then((response) => {
          this.images = response.data;
          loadingComponent.close();
        })
        .catch(() => {
          loadingComponent.close();
          console.log('error');
        });
    },
    sendWhatsapp () {
      if (this.$isMobile()) {
        window.open('https://api.whatsapp.com/send?phone=' + this.params.whatsappNumber + '&text=hola', '_blank');
      } else {
        window.open('https://web.whatsapp.com/send?phone=' + this.params.whatsappNumber + '&text=hola', '_blank');
      }
    }
  }
};
</script>
<style lang="scss">
#carta-iframe {
  margin-top: 60px;
  overflow: auto;
  width: 95%;
  height: 100%;
  .button-menu-digital-language {
    position: absolute;
    top: 30px;
    right: 15px;
    background-color: white;
    padding: 2px 11px;
    border-radius: 9px;
    font-size: 13px;
    &-active {
      font-weight: 600;
    }
    &-pointer {
      cursor: pointer;
    }
  }
  .image-carta {
    width: 100%;
    height: auto;
  }
  #whatsapp {
    position: fixed; /* Fixed/sticky position */
    bottom: 70px; /* Place the button at the bottom of the page */
    right: 15px; /* Place the button 30px from the right */
    border: none; /* Remove borders */
    outline: none; /* Remove outline */
    background-color: var(--buttonBackground); /* Set a background color */
    color: var(--buttonTextColor); /* Text color */
    cursor: pointer; /* Add a mouse pointer on hover */
    padding: 10px; /* Some padding */
    border-radius: 10px; /* Rounded corners */
    font-size: 18px; /* Increase font size */
    z-index: 999;
    box-shadow: none;
    background: rgb(37, 211, 102);
  }
}
.basic {
  width: 100% !important;
  margin-top: 0px !important;
}
</style>
